import React, { useEffect } from "react";
import PropTypes from "prop-types";

const PageTitle = ({ title, onBack, showBackArrow = true }) => {
  useEffect(() => {
    document.title = title;
  }, [title]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        fontFamily: '"Mulish", sans-serif',
        fontWeight: 700,
        fontSize: "1rem",
         marginBottom: "15px", 
      }}
    >
      {onBack && showBackArrow && (
        <button
          onClick={onBack}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 0,
            marginRight: "1rem",
            display: "flex",
            alignItems: "center",
            color: "#000",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M7.828 11H20v2H7.828l5.364 5.364l-1.414 1.414L4 12l7.778-7.778l1.414 1.414z"
            />
          </svg>
        </button>
      )}
      <h2
        style={{
          margin: 0,

          textAlign: "left",
        }}
      >
        {title}
      </h2>
    </div>
  );
};

PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
  onBack: PropTypes.func,
  showBackArrow: PropTypes.bool,
};

export default PageTitle;
